import type { ModulesTagListProps } from "./modules-tag-list.type";

import { Flex } from "antd";

import { Tag } from "@/ui/tag";

const ModulesTagList = ({ modules }: ModulesTagListProps) => {
  if (!modules.length) return null;

  return (
    <Flex gap="6px 0" wrap>
      {modules.map((module) => (
        <Tag key={module.tag}>{module.name}</Tag>
      ))}
    </Flex>
  );
};

export default ModulesTagList;
